import { render, staticRenderFns } from "./DialogAdd.vue?vue&type=template&id=50a194db&"
import script from "./DialogAdd.vue?vue&type=script&lang=js&"
export * from "./DialogAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports